const LabelArt = ({ name, size = "9 oz", compact = false }) => (
  <div className="flex h-full w-full items-center justify-center bg-white p-3">
    <div className="border border-ink/60 p-[3px]">
      <div className={`border border-ink/30 flex flex-col items-center justify-center text-center ${compact ? "px-2 py-3" : "px-5 py-8"}`}>
        <span className={`font-serif italic font-light ${compact ? "text-xs" : "text-xl"}`}>meraRi</span>
        <span className={`font-mono uppercase tracking-[0.3em] text-stone2 ${compact ? "text-[5px]" : "text-[8px]"}`}>Candle Co</span>
        <span className={`mt-3 font-sans font-medium uppercase tracking-[0.18em] ${compact ? "text-[7px]" : "text-xs"}`}>{name}</span>
        <span className={`mt-1 font-mono uppercase tracking-[0.3em] text-stone2 ${compact ? "text-[5px]" : "text-[8px]"}`}>Soy Candle</span>
        {!compact && (
          <>
            <span className="mt-3 text-[7px] font-mono uppercase tracking-[0.2em] text-stone2">Hand Poured in Manayunk<br />With Love</span>
            <span className="my-3 h-px w-10 bg-ink/40" />
            <span className="text-[8px] font-mono uppercase tracking-[0.2em]">{size} / 225.15 G</span>
          </>
        )}
      </div>
    </div>
  </div>
);

export default LabelArt;
